import HomeGhLobbyRail from './HomeGhLobbyRail';

/** Home live-casino rail — mirrors /casino live (GhStyleLobby). */
export default function HomeLiveCasinoRail({ onNavigate }) {
  return <HomeGhLobbyRail lobby="live" onNavigate={onNavigate} />;
}
